import React from 'react';
import Select from './Select';
import withStyles from '@mui/styles/withStyles';

const TimeSelect = ({ form, name, allowNone, useNumbers, ...props }) => {
    return <Select
        options={useNumbers ? TIME_OPTIONS.map(obj => ({
            ...obj,
            value: Number(obj.value)
        })) : TIME_OPTIONS} name={name} form={form} allowNone={allowNone || false}
        {...props} />;
};

// NOTE: your values will need to be strings, numbers are not supported!
export const TIME_OPTIONS = [
    { label: '0 min', value: '0.00' },
    { label: '15 min', value: '0.25' },
    { label: '30 min', value: '0.50' },
    { label: '45 min', value: '0.75' },
    { label: '1 hr', value: '1.00' },
    { label: '1.5 hr', value: '1.50' },
    { label: '2 hrs', value: '2.00' },
    { label: '2.5 hrs', value: '2.50' },
    { label: '3 hrs', value: '3.00' },
    { label: '3.5 hrs', value: '3.50' },
    { label: '4 hrs', value: '4.00' },
    { label: '4.5 hrs', value: '4.50' },
    { label: '5 hrs', value: '5.00' },
    { label: '5.5 hrs', value: '5.50' },
    { label: '6 hrs', value: '6.00' },
    { label: '6.5 hrs', value: '6.50' },
    { label: '7 hrs', value: '7.00' },
    { label: '7.5 hrs', value: '7.50' },
    { label: '8 hrs', value: '8.00' }
];

const styles = () => {
};

export default withStyles(styles)(TimeSelect);
